/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".co-cart__summary[_ngcontent-%COMP%]{position:fixed;width:100%;height:120px;background-color:#fff;bottom:0;z-index:9;left:0}.co-content--skl[_ngcontent-%COMP%]{max-width:1240px}"];
export { styles as styles };
